import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { useStore } from "react-redux";
import apiReportReducer from "./slices/apiReportSlice.ts";
import { chartFieldsReducer } from "./slices/chartStateSlice.ts";
import clientSettingsReducer from "./slices/clientSettingsSlice.ts";
import currentReportReducer from "./slices/currentReportSlice.ts";
import devPanelConfigurationReducer from "./slices/devToolsSlice.ts";
import drillDownConfigurationReducer from "./slices/drillDownConfigurationSlice.ts";
import drillDownPageReducer from "./slices/drillDownPageSlice.ts";
import editingHistoryReducer from "./slices/editingHistorySlice.ts";
import fieldsStateReducer from "./slices/fieldsStateSlice.ts";
import { financialStatementFieldsReducer } from "./slices/financialStatementFieldsSlice.ts";
import { listFieldsReducer } from "./slices/listFieldsSlice.ts";
import measureDatasetsReducer from "./slices/measureDataSetsSlice.ts";
import metaDataReducer from "./slices/metaDataSlice.ts";
import { pivotFieldsReducer } from "./slices/pivotFieldsSlice.ts";
import reportsReducer from "./slices/reportsSlice.ts";
import reportTemplatesReducer from "./slices/reportTemplatesSlice.ts";
import { tabularFieldsReducer } from "./slices/tabularFieldsSlice.ts";
import { tileFieldsReducer } from "./slices/tileFieldsSlice.ts";
import uiSettingsREducer from "./slices/uiSettingsSlice.ts";
import versionHistoryReducer from "./slices/versionHistorySlice.ts";
import type { RootState } from "./types/store.types.ts";

const combinedReducer = combineReducers({
  fieldsStateReducer,
  tabularFieldsReducer,
  pivotFieldsReducer,
  chartFieldsReducer,
  tileFieldsReducer,
  listFieldsReducer,
  financialStatementFieldsReducer,
});

export const store = configureStore({
  reducer: {
    fieldsState: combinedReducer,
    currentReport: currentReportReducer,
    metaData: metaDataReducer,
    measureDatasets: measureDatasetsReducer,
    drillDownPage: drillDownPageReducer,
    drillDownConfiguration: drillDownConfigurationReducer,
    devTools: devPanelConfigurationReducer,
    reportTemplates: reportTemplatesReducer,
    reports: reportsReducer,
    apiReport: apiReportReducer,
    clientSettings: clientSettingsReducer,
    uiSettings: uiSettingsREducer,
    versionHistory: versionHistoryReducer,
    editingHistory: editingHistoryReducer,
  },
});

export const useAppStore = () => useStore<RootState>();

export type AppDispatch = typeof store.dispatch;
